import React from "react";
import { motion } from "framer-motion";
import "./pricing.css";
import FeatureIcon from "./FeatureIcon";

const ComparisonRow = ({
  icon,
  feature,
  subtitle,
  ourAdvantage,
  competitorDisadvantage,
  delay,
}) => {
  return (
    <motion.div
      className="comparison-row"
      initial={{ opacity: 1, y: 0 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay }}
    >
      {/* Feature Column */}
      <div className="feature-cell">
        <div className="feature-icon-wrapper">
          <FeatureIcon type={icon} />
        </div>
        <div className="feature-content">
          <h3 className="feature-title">{feature}</h3>
          <p className="feature-subtitle">{subtitle}</p>
        </div>
      </div>

      {/* Our Advantage Column */}
      <div className="advantage-cell">
        <div className="status-icon advantage-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <div className="status-content">
          <h4 className="status-title">{ourAdvantage.title}</h4>
          <p className="status-subtitle">{ourAdvantage.subtitle}</p>
        </div>
      </div>

      {/* Competitor Disadvantage Column */}
      <div className="disadvantage-cell">
        <div className="status-icon disadvantage-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
          </svg>
        </div>
        <div className="status-content">
          <h4 className="status-title">{competitorDisadvantage.title}</h4>
          <p className="status-subtitle">{competitorDisadvantage.subtitle}</p>
        </div>
      </div>
    </motion.div>
  );
};

export default ComparisonRow;